import { render } from "./CampaignsHeader.vue?vue&type=template&id=42c457d5&scoped=true"
import script from "./CampaignsHeader.vue?vue&type=script&lang=js"
export * from "./CampaignsHeader.vue?vue&type=script&lang=js"

import "./CampaignsHeader.vue?vue&type=style&index=0&id=42c457d5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c457d5"]])

export default __exports__